const GooglePlayIcon = ({ width, height, color, className, onClick, link }) => {
    return (
        <a href={link} target="_blank">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width || 32}
                height={height || 32}
                viewBox="0 0 25 27"
                fill="none"
                className="icon"
                onClick={onClick}
            >
                <path
                    d="M16.253 12.3581L4.29621 0.685681L19.509 9.18812L16.253 12.3581ZM1.17563 0C0.471337 0.358664 0 1.0127 0 1.86189V25.1381C0 25.9873 0.471337 26.6413 1.17563 27L15.0774 13.4974L1.17563 0ZM24.2115 11.8992L21.0205 10.1006L17.4611 13.5026L21.0205 16.9047L24.2765 15.1061C25.2517 14.3518 25.2517 12.6534 24.2115 11.8992ZM4.29621 26.3196L19.509 17.8172L16.253 14.6472L4.29621 26.3196Z"
                    fill="#515151"
                />
            </svg>
        </a>
    );
};

const PCIcon = ({ width, height, color, className, onClick, link }) => {
    return (
        <a href={link} target="_blank">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width || 32}
                height={height || 32}
                viewBox="0 0 28 25"
                fill="none"
                className="icon"
                onClick={onClick}
            >
                <path
                    d="M25.6667 0H2.33333C1.04514 0 0 1.0498 0 2.34375V17.9688C0 19.2627 1.04514 20.3125 2.33333 20.3125H11.6667L10.8889 22.6562H7.38889C6.74236 22.6562 6.22222 23.1787 6.22222 23.8281C6.22222 24.4775 6.74236 25 7.38889 25H20.6111C21.2576 25 21.7778 24.4775 21.7778 23.8281C21.7778 23.1787 21.2576 22.6562 20.6111 22.6562H17.1111L16.3333 20.3125H25.6667C26.9549 20.3125 28 19.2627 28 17.9688V2.34375C28 1.0498 26.9549 0 25.6667 0ZM24.8889 17.1875H3.11111V3.125H24.8889V17.1875Z"
                    fill="#515151"
                />
            </svg>
        </a>
    );
};

export { GooglePlayIcon, PCIcon };
